import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Client } from 'src/app/shared/models/client.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-client-create-modal',
  templateUrl: './client-create-modal.component.html',
  styleUrls: ['./client-create-modal.component.scss']
})
export class ClientCreateModalComponent implements OnInit {

  clientForm: FormGroup;
  @Input() client: Client;
  isEdit: boolean;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.clientForm = this.formBuilder.group({
      client_id      : [''],
      client_name    : ['', [Validators.required, Validators.maxLength(75)]],
      app_name       : ['', [Validators.required, Validators.maxLength(35)]],
      app_description: ['', [Validators.required, Validators.maxLength(256)]],
      allow_access   : [true]
    });

    if (this.client) {
      this.isEdit = true;
      this.clientForm.patchValue({
          client_id      : this.client.client_id,
          client_name    : this.client.client_name,
          app_name       : this.client.app_name,
          app_description: this.client.app_description
        });

      this.clientForm.updateValueAndValidity();
    } else {
      this.clientForm.get('client_id').disable();
    }
  }

  close() {
    this.activeModal.close(
      this.clientForm.value
    );
  }
}
